import './media-selector.scss';

import { loadYoutubeApi } from '../../utilities/js/helper';

class MediaSelector {
    constructor (element) {
        this.$media = element;
        this.mediaType = this.$media.getAttribute('data-media');
        this.$video = null;
    }

    initialize () {
        if (this.mediaType === 'youtube') {
            this.$video = this.$media.querySelector('[data-youtube]');

            import('../../utilities/js/youtube-player').then(({ YoutubePlayer }) => {
                this.initYoutubePlayer(YoutubePlayer);
            });
        }

        if (this.mediaType === 'video') {
            this.$video = this.$media.querySelector('video');
            this.initHTML5Player();
        }
    }

    initYoutubePlayer (YoutubePlayer) {
        if (this.$video) {
            const youtubeId = this.$video.getAttribute('data-youtube');
            const $playButton = this.$media.querySelector('[data-media="play"]');
            let buttonActiveState = true;

            if (youtubeId !== '') {
                const videoPlayer = new YoutubePlayer(this.$video, {
                    muted: !!this.$video.getAttribute('data-muted'),
                    autoplay: !!this.$video.getAttribute('data-autoplay'),
                    fullscreen: !!this.$video.getAttribute('data-fullscreen'),
                    loop: !!this.$video.getAttribute('data-loop'),
                    controls: !!this.$video.getAttribute('data-controls'),
                    root: this.$media,
                    id: youtubeId,
                    observe: true,
                    onCall: () => {
                        this.$media.classList.add('is--shown');
                    },
                    onStart: (videoId) => {
                        this.$media.classList.add('is--shown');
                    },
                    onEnd: (videoId) => {
                        if (videoPlayer.player.video.isMuted() === false) {
                            videoPlayer.destroy();
                            this.$media.classList.remove('is--shown');
                            buttonActiveState = true;
                        }
                    },
                    onPause: (videoId, progress) => {
                        console.log('video pause');
                    }
                });

                const playYoutube = () => {
                    buttonActiveState = false;
                    setTimeout(() => {
                        const $iframe = this.$video.parentElement.querySelector('iframe');
                        if ($iframe) {
                            $iframe.setAttribute('tabindex', '0');
                            $iframe.focus();
                        }
                    }, 300);
                };

                $playButton.addEventListener('keydown', (e) => {
                    if (e.code === 'Space' || e.code === 'Enter') {
                        e.preventDefault();
                        if (buttonActiveState === true) {
                            $playButton.click();
                            playYoutube();
                        }
                    }
                });
            }
        }
    }

    initHTML5Player () {
        const autoplay = (this.$video.getAttribute('autoplay') === '');
        const loop = (this.$video.getAttribute('loop') === '');
        const controls = (this.$video.getAttribute('controls') === '');
        const $playButton = this.$media.querySelector('[data-media="play"]');
        const $pauseButton = this.$media.querySelector('[data-media="pause"]');

        if (autoplay) {
            this.$media.classList.add('is--playing');
            this.$video.load();
        }

        if (!loop) {
            this.$video.addEventListener('ended', () => {
                this.$media.classList.remove('is--playing');

                if (!controls) {
                    showPlayButton();
                }
            });
        }

        if ($playButton) {
            $playButton.addEventListener('click', () => {
                this.$media.classList.add('is--playing');
                showPauseButton();
                this.$video.play();

                if ($pauseButton) {
                    $pauseButton.focus();
                }
            });
        } else {
            this.$video.addEventListener('playing', () => {
                this.$media.classList.add('is--playing');
                showPauseButton();
            });
        }

        if ($pauseButton) {
            $pauseButton.addEventListener('click', () => {
                this.$media.classList.remove('is--playing');
                showPlayButton();
                this.$video.pause();

                if ($playButton) {
                    $playButton.focus();
                }
            });
        } else {
            this.$video.addEventListener('pause', () => {
                this.$media.classList.remove('is--playing');
                showPlayButton();
            });
        }

        const showPauseButton = () => {
            $playButton.setAttribute('data-aria-hidden', 'true');
            $pauseButton.setAttribute('data-aria-hidden', 'false');
        };

        const showPlayButton = () => {
            $pauseButton.setAttribute('data-aria-hidden', 'true');
            $playButton.setAttribute('data-aria-hidden', 'false');
        };
    }
}

export { MediaSelector };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $mediasYoutube = $context.querySelectorAll('[data-media="youtube"]');
        const $mediasVideo = $context.querySelectorAll('[data-media="video"]');

        if ($mediasYoutube.length > 0) {
            if (typeof window.YT === 'undefined') {
                loadYoutubeApi();

                window.onYouTubeIframeAPIReady = () => {
                    $mediasYoutube.forEach(($media) => {
                        const media = new MediaSelector($media);
                        media.initialize();
                    });
                };
            } else {
                $mediasYoutube.forEach(($media) => {
                    const media = new MediaSelector($media);
                    media.initialize();
                });
            }
        }

        if ($mediasVideo.length > 0) {
            $mediasVideo.forEach((media) => {
                const $media = new MediaSelector(media);
                $media.initialize();
            });
        }
    }
});
